// To be replaced with a proper config implementation

export default {
  apiKey: '3Cg61AmD2lyv1IwjGAEpypXncniHvOAq',
  baseUrl: '/',
}
